<template>
  <div 
    class="card" 
    @mouseenter="hoverId = item.codigo"
    @mouseleave="hoverId = null"
    :style="{width: '200px'}"
  >
    <div
      ref="current-speaker"
      class="speaker-img"
      :style="{
        '--zoom-size': `${settings.layout.zoom || '125'}%`,
        backgroundImage: `url('${item.url_avatar}')`,
      }"    
    >

    </div>
    <div class="d-flex flex-column flex pt-4 px-4" >
      <span 
        class="titleCard" 
        :style="{
          color: settings.layout['text-color1'] || '#24252D', 
          fontSize: item.nome.length > 15 ? '18px': '20px'
        }"
      >
      {{item.nome}}
      </span>

      <v-tooltip bottom max-width="220" :disabled="!infoTooltip" :color="settings.layout['tooltip-color']">
        <template v-slot:activator="{ on }">
          <span 
            v-on="on"
            ref="info-speaker"
            class="subtitleCard" 
            :style="{
              color: settings.layout['text-color2'] || '#666D80'
            }"
          >
            {{ getSpeakerInfo }}
          </span>
        </template>
        <div :style="{'font-size': '0.8rem'}">
          <span class="d-block pb-2">
            <b :style="{color: settings.layout['tooltip-text-color'] || '#FFFFFF', 'font-weight': '900'}">
              {{ item.cargo }}
            </b>
          </span>

          <span class="d-block" :style="{color: settings.layout['tooltip-text-color'] || '#FFFFFF'}">
            {{ item.empresa }}
          </span>
        </div>
      </v-tooltip>

      <div 
        :class="['linkedin text-center pt-2']"
        :style="{
          opacity: item.linkedin && (settings.layout.linkedinIcon || hoverId === item.codigo) ? '1' : '0'
        }"
      >
        <v-btn fab color="transparent" class="elevation-0" x-small @click.stop="$emit('onClickLinkedin', item)">
          <v-icon color="bt_color" size="24">fa-brands fa-linkedin</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ["item", "settings"],
  computed: {
    getBoxShadow () {
      const shadow = this.settings.layout.shadow
      const distance = this.settings.layout.distance
      if (shadow) return `${distance}px ${distance}px 0 1px ${shadow}`
      else return 'none'
    },

    getSpeakerInfo () {
      if (this.settings.layout.companyPosition) return `${this.item.cargo} - ${this.item.empresa}`
      else return this.item.empresa
    }    
  },

  data: () => ({
    hoverId: null,
    infoTooltip: false
  }),

  watch: {
    hoverId (id) {
      const currentSpeaker = this.$refs['current-speaker']
      if (id === this.item.codigo) {
        currentSpeaker.style.backgroundSize = `auto var(--zoom-size) !important`
        currentSpeaker.style.filter = `grayscale(0%)`

        const infoSpeaker = this.$refs['info-speaker']
        const isInfoSpeakerEllipsed = infoSpeaker.scrollHeight > infoSpeaker.clientHeight
        this.infoTooltip = isInfoSpeakerEllipsed
      } else {
        currentSpeaker.style.backgroundSize = `auto 100%`
        currentSpeaker.style.filter = `grayscale(100%)`
        this.infoTooltip = false
      }
    }
  }
};
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 200px;
  max-width: 200px;
  border-radius: 32px;
  transition: all 1s;
  padding-bottom: 12px;
}

.card:hover {
  cursor: pointer;
  transform: translateY(-8px);
}

.speaker-img {
  position: relative;
  transition: all 0.5s;
  border-radius: 32px;
  width: 200px;
  height: 225px;
  background-position: center;
  background-size: auto 100%;
  filter: grayscale(100%)
}

.speaker-img:hover {
  cursor: pointer;
  background-size: auto var(--zoom-size) !important;
  filter: grayscale(0%)
}

span {
  display: block;
}

.titleCard {
  font-size: 20px;
  font-style: normal;
  font-weight: 900;
  letter-spacing: 0px;
  line-height: 24px;
  text-align: center;
  overflow: hidden; 
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  max-height: 100%;  
  padding-bottom: 4px;
}

.subtitleCard {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  text-align: center;
  line-height: 18px;
  overflow: hidden; 
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  max-height: 100%;
  color: #666D80
}

.linkedin {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: start;
  transition: opacity 0.3s ease-in-out, visibility 0s linear 0.3s;
}
</style>
